"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
var _exportNames = {
    defaultTranslations: true,
    EditorialPageFeature: true,
    translationsNamespace: true,
    editorialPageMockData: true,
    getEditorialDebug: true
};
Object.defineProperty(exports, "EditorialPageFeature", {
    enumerable: true,
    get: function() {
        return _constants.EditorialPageFeature;
    }
});
Object.defineProperty(exports, "defaultTranslations", {
    enumerable: true,
    get: function() {
        return _constants.defaultTranslations;
    }
});
Object.defineProperty(exports, "editorialPageMockData", {
    enumerable: true,
    get: function() {
        return _editorialPage.editorialPageMockData;
    }
});
Object.defineProperty(exports, "getEditorialDebug", {
    enumerable: true,
    get: function() {
        return _utils.getEditorialDebug;
    }
});
Object.defineProperty(exports, "translationsNamespace", {
    enumerable: true,
    get: function() {
        return _constants.translationsNamespace;
    }
});
var _common = require("./common");
Object.keys(_common).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _common[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _common[key];
        }
    });
});
var _components = require("./components");
Object.keys(_components).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _components[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _components[key];
        }
    });
});
var _constants = require("./constants");
var _containers = require("./containers");
Object.keys(_containers).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _containers[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _containers[key];
        }
    });
});
var _editorialPage = require("./mocks/editorialPage");
var _models = require("./models");
Object.keys(_models).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _models[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _models[key];
        }
    });
});
var _utils = require("./utils");
var _createBannerLayout = require("./utils/createBannerLayout");
Object.keys(_createBannerLayout).forEach(function(key) {
    if (key === "default" || key === "__esModule") return;
    if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
    if (key in exports && exports[key] === _createBannerLayout[key]) return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function() {
            return _createBannerLayout[key];
        }
    });
});
